import * as React from 'react';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { MasterData } from '../shared/index';
import { isNull, getAjaxhelper } from '../utils/index';

export interface LanguangeListProps extends BaseComponentProps {
    lang: string; 
    languageChange: (lang: string) => any;
}
export interface LanguangeListState extends BaseComponentState { 
    languangeList: MasterData.Language[];
    requesting: boolean;
}

export class LanguangeList extends BaseComponent<LanguangeListProps, LanguangeListState> { 

    constructor(props: LanguangeListProps) {
        super(props);
        this.state = {
            languangeList: [],
            requesting: true
        };
    } 

    componentDidMount() {
        this.getData();
    }
    
    getData = () => {
        getAjaxhelper().post(`/dynamics/rest-api/generic/Language`, {
            eraseAuditTrail: true,
            q: {
                status: { $eq: 1 }
            },
        }).then(
            (d: any) => {
                this.setState({ languangeList: d.rows, requesting: false });
            }).catch((exc) => { console.error('error: ', exc); });
    }

    renderLanguageList: () => any = () => {
        let ret: any[] = [];
        if ( !isNull(this.state.languangeList)) {
            for (let x of this.state.languangeList) {
                let className = '';
                let langName: string | any = x.description === "" ? x.name : x.description ;
                let langCode: string = x.code as string ;
                if ( langCode === this.props.lang) {
                    className = 'active';
                    // langName = x.description === "" ? x.name : x.description  ;
                }
                ret.push(
                    <li className={className} key={langCode}>
                        <a 
                            onClick={() => {
                            this.props.languageChange(langCode);
                            }} 
                        > <img style={{width: 23, border: '1px solid #0079ff', borderRadius: 2}} src={`/uploads/flags/${x.code}.svg`} /> - {langName} 
                        </a>
                    </li>
                );
            }
        }
        
        return ret;
    }
    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        let langName: any = <span/>;
        let langname: string = '';
        if ( !isNull(this.state.languangeList)) {
            for (let x of this.state.languangeList) {
                if (x.code === this.props.lang) {
                    langName = <img style={{width: 25, border: '1px solid #0079ff', borderRadius: 2}} src={`/uploads/flags/${x.code}.svg`} /> ;
                    langname = x.name! === '' ? x.description as string : x.name!;
                }
            }
        }
        
        return (
            <li className=" ">
                <a data-toggle="dropdown" href="#" className="dropdown-toggle show-on-desktop"> {langName}</a>
                <a data-toggle="dropdown" href="#" className="dropdown-toggle show-on-mobile"> {langName}  - {langname} </a>
                <ul className="dropdown-menu" >{this.renderLanguageList()}</ul>
            </li>
        );

    }

}


// WEBPACK FOOTER //
// ./src/header/LanguangeList.tsx